<span
  class="tooltip-ajuda"
  (mouseenter)="abrir()"
  (mouseleave)="fechar()"
  (focusin)="abrir()"
  (focusout)="fechar()"
  (keydown.escape)="fechar()"
>
  <button
    type="button"
    class="tooltip-ajuda__icone"
    [attr.aria-label]="rotulo()"
    [attr.aria-describedby]="balaoId"
    data-testid="tooltip-ajuda-icone"
  >
    <img src="assets/images/la_question-circle.svg" alt="" width="14" height="14" />
  </button>

  <span
    [id]="balaoId"
    class="tooltip-ajuda__balao"
    [class.tooltip-ajuda__balao--aberto]="aberto()"
    role="tooltip"
    data-testid="tooltip-ajuda-balao"
  >
    <span class="tooltip-ajuda__texto">{{ texto() }}</span>
  </span>
</span>
